export enum HospitalType {
  Municipal = 'Municipal',
  Private = 'Private',
  Public = 'Public',
}
